module.exports = __webpack_public_path__ + "static/media/devops.c5ad7e93.png";